

import {  Link } from "react-router-dom"
/*
import asyncValidate from './asyncValidate'
*/
import  SVADocComponentEp  from '../core/SVADocComponentEp'
//import {SVADocComponentEp} from '../core/SVADocComponentEp'
import {SVCDeviceComponentEp} from '../core/SVCDeviceComponentEp'
import {SVATripperComponentEp} from '../core/SVATripperComponentEp'

import {SVBDDInputEp} from '../core/svbddinputEp'
/*
import {loadAddressDataDB as loadAccount } from '../../redux/svractions/svreviewActions'
*/
/*import {flyLoadAddressData as loadFlyAddressDataDB } from '../../redux/svractions/svflyreviewActions'
*/
import {flyLoadsvtocData as loadFlyTocDataDB } from '../../redux/svractions_cosmos/svflyreviewActions_cosmos'
import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'
import { Alert,Icon, Card , Button as SVAButton} from 'antd';

import {SVTPPFORM} from '../../constants'
/*makes form entry very slow do not use in nested forms
import asyncValidateCrtoc from './asyncValidateCrtoc'
*/
import '../../css/svformwerror.css'

const React = require('react')

const {connect}  = require("react-redux")
const _ = require('lodash')


const svChange = (values, dispatch, props, valuesPrev)=>{

  console.log('sv form change')

  console.log(values)


}


const normalizeNumber = value=>{

  let outValue = value

  if(!value){
      return outValue
  }

  const onlyNums = value.replace(/[^\d]/g, '')

  outValue = onlyNums
  console.log(onlyNums)
  return outValue
  //return outValue
}


const portTypes=[{
    key:'CL_Number',
    value:'number'
  },{
    key:'CL_String',
    value:'string'
  
  },{
    key:'CL_Date',
    value:'date'   
   
  }]
  
  const svtypes= ['single', 'double', 'complex']
  
  //inputSchemaType

const holderTypes = [{
    name:'CL_Y',
    value:'Y'
  },{
    name:'CL_N',
    value:'N'
  
  }]
  const genderTypes = [{
    name:'CL_MALE',
    value:'MALE'
  },{
    name:'CL_FEMALE',
    value:'FEMALE'
  
  }] 
  const deviceTypes = [{
    name:'CL_MOBILE',
    value:'MOBILE'
  },{
    name:'CL_PAGER',
    value:'PAGER'
  
  }]
  
const documentTypes = [{
    name:'CL_PASSPORT',
    value:'PASSPORT'
  },{
    name:'CL_IDENTITY_CARD',
    value:'IDENTITY_CARD'
  
  }]
  const inputSchemaTypes = [{
    name:'JSON',
    value:'JSON'
  },{
    name:'XML',
    value:'XML'
  },{
    name:'SVG',
    value:'SVG'
  }]
  const locationTypes = [{
      name:'START',
      value:'START'
  },{
      name:'CARRIER',
      value:'CARRIER'
  },{
      name:'END',
      value:'END'
  }]
  const transformToBA =(values)=>{
    let data ={
        id: values.id ||'addLeft_STEP',
        gene: values.gene ||'addLeft_STEP',
        lastName:'add_step',
        portType:'number',
        portInput :10,
        location:'START'
       
    
    }
  
   let members = values.members
  let  o ={
    id:data.id,
    inputPorts:['portA', 'portB'],
    gene:data.gene,
    location:data.location,
    input:{
        bindingType:'json',
        portA:{
            input:data.portInput,
            type:data.portType
  
        },
        portB:{
            input:20,
            type:'number'
  
        }
    }
  }  
  let   portResolved = _.findWhere(members, {portName:'portA'})
  if(portResolved){
    o.input['portA']= {
      input:portResolved.portInput,
      type: portResolved.portType
    }
    
  
  }
  
  portResolved = _.findWhere(members, {portName:'portB'})
  if(portResolved){
    o.input['portB']= {
      input:portResolved.portInput,
      type:portResolved.portType
    }
  
  }
  

  return o
  
  }
  let data ={
      id:'addLeft_STEP',
      gene:'addLeft_STEP',
      lastName:'add_step',
      portType:'number',
      portInput :10,
      location:'START'
  }


const renderMembersPort=(o)=>{
  const {fields, meta:{error, submitFailed}} =o
  /*
  let members = [
            {
                "tid": 1,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "svkap",
                "lastName": "sval",
                "emailAddress": "svr@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "34",
                        "number": "480080085"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP",
                "gene": "addLeft_STEP",
                "clubName": "Soccer"
            },
            {
                "tid": 2,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "Seteve",
                "lastName": "Borrow",
                "emailAddress": "steve@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "1",
                        "number": "480080081"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP1",
                "gene": "addLeft_STEP1",
                "clubName": "SVCriuseBALL"
            }
        ]
  console.log(o)
  */
   console.log('renderMembers should generate empty object')
  // let fields = members
     console.log(fields)
   return(<ul>
     {/*  
     <SVADocComponentEp holderTypes={holderTypes} documentTypes={documentTypes} inputSchemaTypes={inputSchemaTypes} locationTypes={locationTypes}  portTypes={portTypes} member={member} index={index} />
              
     */}
       <li>
         
       <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add Traveller </button>
       { submitFailed && error && <span>{error} </span>}
       </li>
       {
            fields.map((member, index) => {
                console.log(o)
                
               return(
               <li key={index}>
                 
                

                 <div className="card card--raised with-shadow">
                 <span  onClick={() => fields.remove(index)} className="c-span"><text style={{fontWeight:"700"}}>Travellerk #{index + 1}</text><Icon  style={{ color: 'rgb(238, 56, 56)' }} type="delete" theme="filled" /> </span>
                
                                          
                                           


                                          <div style={{marginTop:"10px"}} className="form-group">
                                          <label htmlFor={`${member}.tid`}> tid</label>
                                                    
                                                    <Field
                                                    normalize={normalizeNumber} 
                                                        id={`${member}.tid`}
                                                        name={`${member}.tid`}
                                                        name="tid"
                                                        type="text"
                                                        placeholder=""
                                                        component="input"
                                                        className="form-control"
                                                    />
                                                

                                            </div>
                                            <div className="form-group">
                                            <label htmlFor={`${member}.lastName`}> Last Name</label>
                                                    
                                                    <Field
                                                
                                                        id={`${member}.lastName`}
                                                        name={`${member}.lastName`}
                                                        
                                                        type="text"
                                                        placeholder="svinfinity"
                                                        component="input"
                                                        className="form-control"
                                                    />
                                                

                                            </div>
                                            <div className="form-group">
                                            <label htmlFor={`${member}.firstName`}> First Name</label>
                                                    
                                                    <Field
                                                
                                                   
                                                    id={`${member}.firstName`}
                                                    name={`${member}.firstName`}
                                                        placeholder="SV"
                                                        component="input"
                                                        className="form-control"
                                                    />
                                    
                                            </div>
                                            <div className="form-group">
                                                   <label htmlFor={`${member}.gender`}  > Gender</label>
                                                                <Field  component="select" id={`${member}.gender`}  name={`${member}.gender`} className="form-control" >
                                                                    <option value="">Select Gender</option>
                                                                    {

                                                                        genderTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                                            
                                                                
                                                                )}
                                                        
                                                                </Field>
                                    
                                            </div>
                                            <div className="form-group">
                                            <label htmlFor={`${member}.emailAddress`}> emailAddress</label>
                                                    
                                                    <Field
                                                
                                                   
                                                       
                                                        id={`${member}.emailAddress`}
                                                        name={`${member}.emailAddress`}
                                                        type="text"
                                                        placeholder="sv@sv.com"
                                                        component="input"
                                                        className="form-control"
                                                    />
                                            </div>
                                            <div className="form-group">
                                            <label htmlFor={`${member}.dateOfBirth`}> dateOfBirth</label>
                                                    
                                                    <Field
                                                
                                                id={`${member}.dateOfBirth`}
                                                name={`${member}.dateOfBirth`}
                                                        type="text"
                                                        placeholder="1982-01-15"
                                                        component="input"
                                                        className="form-control"
                                                    />
                                    
                                            </div>
                                            
                                            <div className="o-container-fpplist">
                                                
                                                  <div className="o-box-fpplist-b1">
                                                    <FieldArray   name={`${member}.memphones`} component={renderMembersPHone} />
                                              
                                                  </div>
                                                  <div className="o-box-fpplist-b1">
                                                    <FieldArray  name={`${member}.members`}  component={renderMembersDriver} />
                                                    
                                              
                                                  </div>
                                            </div>
                                            
                                           
                                           
                                    
                                           
                                        
                                        
                                    
                        </div>

               
                           </li>
             )})

       }
      
      

       </ul> )
      
}


  const renderMembersPHone=(o)=>{
    /*
    causes rcursion loop
    const {countryTypes, isdcodeTypes, genderTypes,stateTypes} = this.props.my_data_geo
    
   */
 
    const {fields, meta:{error, submitFailed}} =o
    let memphones =[
      {
          
          "deviceType": "MOBILE",
          "countryCallingCode": "34",
         
          
          "number": "480080085"
      },
      {
          
        "deviceType": "PAGER",
        "countryCallingCode": "34",
       
        
        "number": "480080087"
    }
  ]
    console.log(o)
     console.log('renderMembersPHone should generate empty object')
    // let fields = members
       console.log(fields)
     return(<ul>
  
         <li>
         <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add Device </button>
         { submitFailed && error && <span>{error} </span>}
         </li>
         {
              fields.map((member, index) => {
                  console.log(o)
                  
                 return(
                 <li key={index}>
                   
                   <Card title="" bordered={true} style={{ width: 300 }}>
                   <span  onClick={() => fields.remove(index)} className="c-span"><text style={{fontWeight:"700"}}>Device #{index + 1}</text><Icon  style={{ color: 'rgb(238, 56, 56)' }} type="delete" theme="filled" /> </span>
                  {/* 
                   <SVCDeviceComponentEp isdcodeTypes={isdcodeTypes} deviceTypes={deviceTypes} member={member} index={index} />
                 
                  */}
                   <SVCDeviceComponentEp deviceTypes={deviceTypes} member={member} index={index} />
                 
                    </Card>
                 </li>
               )})
  
         }
        
        
  
         </ul> )
        
  }

const renderMembersDriver=(o)=>{
    const {fields, meta:{error, submitFailed}} =o
    let members =[
        {
          "documentType": "IDENTITY_CARD",
          "birthPlace": "Madrid",
          "issuanceLocation": "Madrid",
          "issuanceDate": "2015-04-13",
          "documentNumber": "00000069",
          "expiryDate": "2025-04-13",
          "issuanceCountry": "ES",
          "validityCountry": "ES",
          "nationality": "ES",
          "holder": "Y"
        }
      ]
    console.log(o)
     console.log('renderMembers should generate empty object')
    // let fields = members
       console.log(fields)
     return(<ul>
  
         <li>
         <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add Port </button>
         { submitFailed && error && <span>{error} </span>}
         </li>
         {
              fields.map((member, index) => {
                  console.log(o)
                  
                 return(
                 <li key={index}>
                   
                   <Card title="" bordered={true} style={{ width: 300 }}>
                   <span  onClick={() => fields.remove(index)} className="c-span"><text style={{fontWeight:"700"}}>Travel Document #{index + 1}</text><Icon  style={{ color: 'rgb(238, 56, 56)' }} type="delete" theme="filled" /> </span>
                
                  
                    <SVADocComponentEp holderTypes={holderTypes} documentTypes={documentTypes} inputSchemaTypes={inputSchemaTypes} locationTypes={locationTypes}  portTypes={portTypes} member={member} index={index} />
                    </Card>
                    
                  
                 </li>
               )})
  
         }
        
        
  
         </ul> )
        
  }
const showCruiseErrorAlert = (marerrob)=>{
  //save crMarinerErrorOb in redux reducer and use trhat to show alert
  //following is init data not the form data . nectPage has formData taht create abd savce crMarinerErrorOb ser 
  console.log(marerrob)
  let gob = {
    "hasErrors": false,
    "error": "",
    "message": "No Error",
    "field":"Travellers"
}
  if(marerrob){
    gob = marerrob
  }
  //init data not form data 
  /*
  let mouter = toc.members
  let nmariners = mouter.length
   console.log('svapr14** nmariners size ', nmariners)
   let hasErrors = true
  */
 
  
  /*
  if((nmariners > 1) && ( nmariners < 6)){
    return (<div></div>)
  }else{
    console.log('validation error cruise cabin needs min 2 guests and max 5 guest per cabin, Use group booking by calling live agent to prevent creditr card charge back and dierc bank account and book manullay cabins by calling svadmin ')
  }*/
  const {hasErrors, message, error,field} = gob
  let sm = "Number of Travellers should be in range  2 to 5  "

  if(hasErrors ){
    if(message){
      sm = message
    }
    return ( <div>
           
   
      <Alert   message={sm} type="error" />
    
              
          </div>)
  }
}
  /*sv n12 START*/
const renderMemberCard=(o)=>{
  const {fields, meta:{error, submitFailed}} =o
  console.log(o)
     console.log('renderMembers should generate empty object')
    // let fields = members
       console.log(fields)
  return(<ul>
  
    <li>
    <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add Port </button>
    { submitFailed && error && <span>{error} </span>}
    </li>
    {
         fields.map((member, index) => {
             console.log(o)
             
            return(
            <li key={index}>
              <button
                type="button"
                className="btn btn-default"
               
                onClick={() => fields.remove(index)}
              >Remove</button>
              <h4>Person #{index + 1}</h4>
             
              <SVATripperComponentEp holderTypes={holderTypes} documentTypes={documentTypes} inputSchemaTypes={inputSchemaTypes} locationTypes={locationTypes}  portTypes={portTypes} member={member} index={index} />
               
             
            </li>
          )})

    }
   
   

    </ul> )

}
  /*SV N12 EDN */
  const getPortValue = (key)=>{
    let o = _.findWhere(portTypes, {key:key})
    return o.value
  }
const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )

  let dcountries = [{
    name:'United States Of America',
    value:'usa'

  },{
    name:'France',
    value:'France'
  },{

    name:'China',
    value:'China'
},{
    name:'Mexico',
    value:'Mexico'
  
  }]


let genes = [{
    name:'add_step',
    value:'add_step'

  },{
    name:'multiply_seq_step',
    value:'multiply_seq_step'
  },{

    name:'sq_step',
    value:'sq_step'
},{
    name:'sr_step',
    value:'sr_step'
  
  }]


  let validate =(formData)=>{
    console.log('svapr14***--valudare fprmData')
      console.log(formData)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            console.log(errors)
            return errors
        }
       
        if(!formData.isdcode){
            errors.isdcode= 'Required'
        }
      
       console.log('FlyPaymentDEtailFormBusCom validate error *************')
        console.log(errors)
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
       
        return o
    }
class FlyPaymentDocumentFormBus extends React.Component{
    
  render(){
    console.log('sv... SVCDnaStepFormBus')
    /*svj21 start*/
    const {countryTypes,countryTwoTypes, isdcodeTypes, genderTypes,stateTypes} = this.props.my_data_geo
// let countryTwoTypes = countryTypes
   console.log('svj21*********isdcodeTypes****start')
   console.log(isdcodeTypes)
   console.log(countryTwoTypes)
   console.log('svj21*********isdcodeTypes****end')
      /*svj21 end*/
    /* causes recursion issue loop
    const {countryTypes, isdcodeTypes, genderTypes,stateTypes} = this.props.my_data_geo
    */
    const { handleSubmit, pristine, error,reset, submitting } = this.props
    const { load, initialValues } = this.props
    //we always get iniitalValues that is default the form uses as kv pair 
    //const { initialValues,load, handleSubmit,loadGeneTemplate,  pristine, reset, submitting, submit, startSubmit } = this.props 
   //we are copying all members from initialValues and senfint to props
   /* const {initialValues} = this.props
   

    */
    console.log("SVTPPFORM gets initialValues aka formdata  ")
    console.log(initialValues)
    console.log(this.props)
    return (
        <div>
           {showCruiseErrorAlert(this.props.marerrob)}
         
            <form  onSubmit={handleSubmit}>
            <div className="rev-row">
                        

                        <FieldArray name="members" component={this.renderMembersPortCurry(isdcodeTypes,countryTwoTypes,this)} />
                                                      
                                              {/* 
                                           <FieldArray name="members" component={renderMembersPort} />
                                            */}
                                           
                                           
                                    
                                           
                                        
                                        
                                    
                       

   
    
                   
                   
                   
                        <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
                            Next -  Payment Card
                        </button>   
                        <button type="button" className="btn btn-success" onClick={this.props.previousPage}>
                        Previous - Booking Details
                        </button>
                        <button type="button" onClick={() => load(data)}>
                        Load Account
                        </button>
    
                   
                    </div>
                
                    
            </form>
        
        </div>
     )
}

/*svj21 start*/
 renderMembersPortCurry =(isdcodeTypes ,countryTwoTypes, ctx)=>(o)=>{
  console.log("*******svj2****curry** START")
  console.log(isdcodeTypes)
  console.log(countryTwoTypes)
  console.log(ctx)
  console.log(o)
  console.log("*******svj2****curry** MID")
  const {fields, meta:{error, submitFailed}} =o
  /*
  let members = [
            {
                "tid": 1,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "svkap",
                "lastName": "sval",
                "emailAddress": "svr@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "34",
                        "number": "480080085"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP",
                "gene": "addLeft_STEP",
                "clubName": "Soccer"
            },
            {
                "tid": 2,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "Seteve",
                "lastName": "Borrow",
                "emailAddress": "steve@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "1",
                        "number": "480080081"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP1",
                "gene": "addLeft_STEP1",
                "clubName": "SVCriuseBALL"
            }
        ]
  console.log(o)
  */
   console.log('renderMembers should generate empty object')
  // let fields = members
     console.log(fields)
   return(<ul>
     {/*  
     <SVADocComponentEp holderTypes={holderTypes} documentTypes={documentTypes} inputSchemaTypes={inputSchemaTypes} locationTypes={locationTypes}  portTypes={portTypes} member={member} index={index} />
              
     */}
       <li>
         
       <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add Traveller </button>
       { submitFailed && error && <span>{error} </span>}
       </li>
       {
            fields.map((member, index) => {
                console.log(o)
                
               return(
               <li key={index}>
                 
                

                 <div className="card card--raised with-shadow">
                 <span  onClick={() => fields.remove(index)} className="c-span"><text style={{fontWeight:"700"}}>Travellerk #{index + 1}</text><Icon  style={{ color: 'rgb(238, 56, 56)' }} type="delete" theme="filled" /> </span>
                
                                          
                                           


                                          <div style={{marginTop:"10px"}} className="form-group">
                                          <label htmlFor={`${member}.tid`}> tid</label>
                                                    
                                                    <Field
                                                    normalize={normalizeNumber} 
                                                        id={`${member}.tid`}
                                                        name={`${member}.tid`}
                                                        name="tid"
                                                        type="text"
                                                        placeholder=""
                                                        component="input"
                                                        className="form-control"
                                                    />
                                                

                                            </div>
                                            <div className="form-group">
                                            <label htmlFor={`${member}.lastName`}> Last Name <span class="svr-required">*</span></label>
                                                    
                                                    <Field
                                                
                                                        id={`${member}.lastName`}
                                                        name={`${member}.lastName`}
                                                        
                                                        type="text"
                                                        placeholder="svinfinity"
                                                        component="input"
                                                        className="form-control"
                                                    />
                                                

                                            </div>
                                            <div className="form-group">
                                            <label htmlFor={`${member}.firstName`}> First Name <span class="svr-required">*</span></label>
                                                    
                                                    <Field
                                                
                                                   
                                                    id={`${member}.firstName`}
                                                    name={`${member}.firstName`}
                                                        placeholder="SV"
                                                        component="input"
                                                        className="form-control"
                                                    />
                                    
                                            </div>
                                            <div className="form-group">
                                                   <label htmlFor={`${member}.gender`}  > Gender <span class="svr-required">*</span></label>
                                                                <Field  component="select" id={`${member}.gender`}  name={`${member}.gender`} className="form-control" >
                                                                    <option value="">Select Gender</option>
                                                                    {

                                                                        genderTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                                            
                                                                
                                                                )}
                                                        
                                                                </Field>
                                    
                                            </div>
                                            <div className="form-group">
                                            <label htmlFor={`${member}.emailAddress`}> Email <span class="svr-required">*</span></label>
                                                    
                                                    <Field
                                                
                                                   
                                                       
                                                        id={`${member}.emailAddress`}
                                                        name={`${member}.emailAddress`}
                                                        type="text"
                                                        placeholder="sv@sv.com"
                                                        component="input"
                                                        className="form-control"
                                                    />
                                            </div>
                                            <div className="form-group">
                                            <label htmlFor={`${member}.dateOfBirth`}> Date Of Birth(Donot click X on Datepickers)<span class="svr-required">*</span></label>
                                             {/*    <Field
                                                
                                                id={`${member}.dateOfBirth`}
                                                name={`${member}.dateOfBirth`}
                                                        type="text"
                                                        placeholder="1982-01-15"
                                                        component="input"
                                                        className="form-control"
                                                    />
              

      */} 
                                                    
                                                    <SVBDDInputEp member={member} index={index} placeholder="2015-04-13" /> 

                                    
                                            </div>
                                            
                                            <div className="o-container-fpplist">
                                                      
                                                  <div className="o-box-fpplist-b1">
                                                    {/*svj21 start   <FieldArray   name={`${member}.memphones`} component={renderMembersPHone} /> */}
                                                    <FieldArray   name={`${member}.memphones`} component={this.renderMembersPHoneCurry(isdcodeTypes,this)} />
                                              
                                                  </div>
                                                  <div className="o-box-fpplist-b1">
                                                     {/*svj21 start    <FieldArray  name={`${member}.members`}  component={renderMembersDriver} /> */}
                                                    <FieldArray  name={`${member}.members`}  component={this.renderMembersDriverCurry(countryTwoTypes,this)} />
                                                    
                                              
                                                  </div>
                                            </div>
                                            
                                           
                                           
                                    
                                           
                                        
                                        
                                    
                        </div>

               
                           </li>
             )})

       }
      
      

       </ul> )
  console.log("*******svj2****curry** END")
}

 renderMembersPHoneCurry=(isdcodeTypes, ctxThis)=>(o)=>{
  /*
  causes rcursion loop
  const {countryTypes, isdcodeTypes, genderTypes,stateTypes} = this.props.my_data_geo
  
 */

  const {fields, meta:{error, submitFailed}} =o
  let memphones =[
    {
        
        "deviceType": "MOBILE",
        "countryCallingCode": "34",
       
        
        "number": "480080085"
    },
    {
        
      "deviceType": "PAGER",
      "countryCallingCode": "34",
     
      
      "number": "480080087"
  }
]
  console.log(o)
   console.log('renderMembersPHone should generate empty object')
  // let fields = members
     console.log(fields)
   return(<ul>

       <li>
       <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add Device </button>
       { submitFailed && error && <span>{error} </span>}
       </li>
       {
            fields.map((member, index) => {
                console.log(o)
                
               return(
               <li key={index}>
                 
                 <Card title="" bordered={true} style={{ width: 300 }}>
                 <span  onClick={() => fields.remove(index)} className="c-span"><text style={{fontWeight:"700"}}>Device #{index + 1}</text><Icon  style={{ color: 'rgb(238, 56, 56)' }} type="delete" theme="filled" /> </span>
                {/* svj21 start
                <SVCDeviceComponentEp deviceTypes={deviceTypes} member={member} index={index} />
               
                
                */}
                  <SVCDeviceComponentEp isdcodeTypes={isdcodeTypes} deviceTypes={deviceTypes} member={member} index={index} />
               
                  </Card>
               </li>
             )})

       }
      
      

       </ul> )
      
}
renderMembersDriverCurry=(countryTwoTypes,ctxThis)=>(o)=>{
  const {fields, meta:{error, submitFailed}} =o
  let members =[
      {
        "documentType": "IDENTITY_CARD",
        "birthPlace": "Madrid",
        "issuanceLocation": "Madrid",
        "issuanceDate": "2015-04-13",
        "documentNumber": "00000069",
        "expiryDate": "2025-04-13",
        "issuanceCountry": "ES",
        "validityCountry": "ES",
        "nationality": "ES",
        "holder": "Y"
      }
    ]
  console.log(o)
   console.log('renderMembers should generate empty object')
  // let fields = members
     console.log(fields)
   return(<ul>

       <li>
       <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add Port </button>
       { submitFailed && error && <span>{error} </span>}
       </li>
       {
            fields.map((member, index) => {
                console.log(o)
                
               return(
               <li key={index}> 
                 
                 <Card title="" bordered={true} style={{ width: 300 }}>
                 <span  onClick={() => fields.remove(index)} className="c-span"><text style={{fontWeight:"700"}}>Travel Document #{index + 1}</text><Icon  style={{ color: 'rgb(238, 56, 56)' }} type="delete" theme="filled" /> </span>
              
                
                  <SVADocComponentEp countryTwoTypes={countryTwoTypes} holderTypes={holderTypes} documentTypes={documentTypes} inputSchemaTypes={inputSchemaTypes} locationTypes={locationTypes}  portTypes={portTypes} member={member} index={index} />
                  </Card>
                  
                
               </li>
             )})

       }
      
      

       </ul> )
      
}

/*svj21 end*/
fsHome(){
  return (
      
              <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#e91b1b'}} type="primary" shape="round"  size="{size}" ><Link to={`/svlogin`}> My Reservations   </Link></SVAButton>
  
         )
}
    constructor(props){
        super(props)
        this.fsHome = this.fsHome.bind(this)
       
        this.loadGene = this.loadGene.bind(this)
        this.ddChange = this.ddChange.bind(this) 
        /*svj21 start*/
        let me = this
        this.renderMembersPortCurry =this.renderMembersPortCurry.bind(me)
        this.renderMembersPHoneCurry = this.renderMembersPHoneCurry.bind(me)
        this.renderMembersDriverCurry = this.renderMembersDriverCurry.bind(me)
        /*svj21 end*/
        /*
        this.getAppDetails = this.getAppDetails.bind(this)
        */
       
    }
    componentWillMount()	{
        console.log('sv--Nov3 call DocumentData  should needs addressid action load to gtethe formvalues tppForm')
        const { custProfile, my_data_flyaddress, my_data_card} = this.props
         console.log('sv***--Nov3 load Step1  PaymentDocument  DocumentData custProfile  from SVWizard+')
       const {   my_data_svtoc} = this.props
         console.log('sv-- AmbStepFormEp  PaymentData custProfile  from SVWizard+')
      
       
        console.log(my_data_svtoc)
         console.log('sv--AmbStepFormEp dcustProfile from  SVWizrd end')
         if( my_data_svtoc && (my_data_svtoc.members.length > 0)){
            console.log('sv--AmbStepFormEp dcustProfile from  SVWizrd calls load ')
            console.log(my_data_svtoc)
            this.props.load(my_data_svtoc)
         }else{
            this.props.load()
         }
        
        
    console.log('sbv--AmbStepFormEp sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:')
    
    
	}
    
    loadGene(e){
        console.log(e)
    }
    ddChange(e){
        
        console.log(e)
        console.log('gene name:' +this.props.gene)

        let o = _.findWhere(genes,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }
   
}

const tppForm = reduxForm({

    form:SVTPPFORM,
    validate:validate,
 
   /* asyncValidate: asyncValidateCrtoc, */
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(FlyPaymentDocumentFormBus)

const selector = formValueSelector(SVTPPFORM)


let CRPaymentTocumentFormBusCom =connect((state=>{
    //we are not using key nmae intiailValues rathre returning flat content ky/valu as fpdData
    //reducForm provideis built in load - we have tp provide our action here  then our form component can call load from props
    //we cannot mofifiy initial Valy=ues or statehere only in reducers
//we have action loadAddressData from reviewaction that modiefied fpdData in TaskReducer. the address data is stored in this form. we will add card data also in fpdData
    let plucked = state.movies
    console.log('sv***FlyPaymentDocuments taskreducers')
    console.log(plucked)
    let custProfile = state.crreviewView.custProfile
   
    let my_data_flyaddress = state.crreviewView.cr_data_address
    let my_data_svtoc = state.crreviewView.my_data_svtoc
    let my_data_card = state.crreviewView.cr_data_card
    /*svapr14 start */
    let marerrob = state.crreviewView.marerrob
    let o = {initialValues:plucked.fppData , "marerrob":marerrob,"my_data_svtoc":my_data_svtoc,"my_data_card":my_data_card,"my_data_flyaddress":my_data_flyaddress, "custProfile":custProfile}
     /*svapr14 end */
    selector(state, 'id')
    console.log('sv apr12 initial values Payment Address info*********PAyment Address apr12')
    console.log(o)
     
    //return plucked.fpdData
    return o
}),{
    //load:loadPdMyReservatiionsAddressAction,
    load:loadFlyTocDataDB,
    
    
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(tppForm)





export default CRPaymentTocumentFormBusCom